import React from "react";
import "./About.css"
import NavBar from "../NavBar/NavBar";
import Footer from "../Footer/Footer";
import raeanneProfile from "./images/IMG_1578.jpg";
import logistics from "./images/logistics.png";
import food from "./images/food.png";
import transportation from "./images/transportation.png";
import souvenirs from "./images/souvenirs.png";
import members from "./images/member-map.png";

class About extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div>
                <NavBar/>
                <div id="about">
                    <div style={{opacity:"70%"}} className="about-content">
                        <div className="about-inner" id="whoweare">
                            <h2>Who We Are</h2>
                            <p>Kids in Seats is a 501(c)(3) non-profit organization that promotes achievement in 
                                disadvantaged youth by using event experiences as motivational tools to recognize 
                                and reward their academic achievement and positive social behavior.
                            </p>
                        </div>

                        <div className="about-inner" id="outcomes">
                            <h2>Outcomes</h2>
                            <p>Rewarding and recognizing positive behavior is a well documented motivator for children 
                                to repeat that behavior. It also helps keep children focused, enhances their self-esteem, 
                                assists in teaching personal discipline and creates memories that last a lifetime.
                            </p>
                        </div>
                    </div>
                </div>
                <div id="money-goes">
                    <h2>WHERE YOUR MONEY GOES</h2>
                    <div id="destination-container">
                        <div className="money-destination">
                            <img src={logistics} alt="logistics"/>
                            <p>LOGISTICS FOR EACH EVENT</p>
                        </div>
                        <div className="money-destination">
                            <img src={food} alt="food"/>
                            <p>FOOD AND DRINK AT THE EVENT</p>
                        </div>
                        <div className="money-destination">
                            <img src={transportation} alt="transportation"/>
                            <p>TRANSPORTATION TO THE EVENT</p>
                        </div>
                        <div className="money-destination">
                            <img src={souvenirs} alt="souvenirs"/>
                            <p>SOUVENIRS AT THE EVENT</p>
                        </div>
                    </div>
                    <p className="money-follow">Our programs make the experience complete and memorable for our kids.</p>
                    <p className="money-follow">Over the past 12 years, the staff of Kids in Seats has incentivized more than 196,000 youth with event tickets valued at more than $11.3 million.</p>
                </div>
                <div id="reach">
                    <h2>OUR REACH</h2>
                    <img src={members} alt="member map"/>
                </div>
                <div className="people-display">
                        <h2>MEET OUR TEAM</h2>
                        <div className="person-container">
                            <img src={raeanneProfile} alt="Rae Anne Mclaughlin"/>
                            <h4>Rae Anne McLaughlin, Vice President</h4>
                            <p>Rae Anne has a rich history working with teams, venues, ticket holders/donors 
                                and ticket recipients. Over the past 10 years over 175K tickets with a face value 
                                of over $90 million have been placed through her program implementation. 
                                As a longtime advocate for displaced youth, she spent  twenty years developing and 
                                implementing youth residential programs serving the New York State Runaway and Homeless 
                                division, Office of Mental Health, and Nassau County Foster Care.</p><p className="bring-close">She brings a deep 
                                understanding of the importance of structuring at-risk and under-served youth leisure 
                                time as a means of ensuring successful entry into adulthood.  Rae Anne has a rich history 
                                of working with government agencies advocating for change in educational laws and standards 
                                for under-privileged and under-served children. Rae Anne is extensively trained in the McKinney 
                                Vento Act, and has worked with government agencies to improve laws protecting homeless children. 
                                Rae Anne holds a MSW and a NYS CASAC.</p>
                        </div>
                    </div>
                <Footer/>
            </div>
        )
    }
}

export default About;

/*

*/